export default class Utils {
  static nullValitor(val: any) {
    if (val !== '' && val !== undefined && val !== null && val !== [] && val !== false) {
      return true;
    } else {
      return null;
    }
  }

  static isEmpty(obj: {}) {
    for (var prop in obj) {
      if (obj.hasOwnProperty(prop)) {
        return false;
      }
    }
    return JSON.stringify(obj) === JSON.stringify({});
  }

  static convertDate(str: string, type: string) {
    let value = JSON.stringify(str);
    let mnths = {
        Jan: '01',
        Feb: '02',
        Mar: '03',
        Apr: '04',
        May: '05',
        Jun: '06',
        Jul: '07',
        Aug: '08',
        Sep: '09',
        Oct: '10',
        Nov: '11',
        Dec: '12',
      },
      date = value.split('-');
    switch (type) {
      case 'full':
        return [date[3], mnths[date[1]], date[2]].join('-');
      case 'year':
        return value.split('-')[0];
      default:
        return [date[3], mnths[date[1]], date[2]].join('-');
    }
  }
}
